import * as React from 'react'
import { tw } from 'utils/classnames'

import { Slot } from '../slot'
import { SearchIcon } from '../icons'

const SearchRoot = function Search({
  ref,
  children,
  iconPosition = 'left',
  containerClassName,
  ...props
}: React.ComponentProps<'input'> & {
  iconPosition?: 'left' | 'right'
  containerClassName?: string
}) {
  return (
    <div className={tw('relative flex w-full items-center', containerClassName)}>
      <input
        type="search"
        {...props}
        ref={ref}
        className={tw(
          'rounded-2 text-16 sm:text-14 bg-gray-700-100 font-inter peer w-full py-2 pl-[36px] pr-[6px] text-gray-300 placeholder:text-gray-300',
          iconPosition === 'left' ? 'pl-[36px] pr-[6px]' : 'pl-[6px] pr-[36px]',
          props.className,
        )}
      />
      <SearchIcon
        className={tw(
          'pointer-events-none absolute size-[18px] min-h-[18px] min-w-[18px] text-gray-300 sm:top-3 sm:size-4 sm:min-h-4 sm:min-w-4',
          iconPosition === 'left' ? 'left-3' : 'right-3',
        )}
      />
      {children}
    </div>
  )
}

const SearchIconRight = function SearchIconRight({
  ref,
  asChild,
  ...props
}: AsChildGuard<'div', 'className' | 'children'> & {
  ref?: React.RefObject<HTMLDivElement>
}) {
  const Component = asChild ? Slot : 'div'

  return (
    <Component
      {...props}
      ref={ref}
      className={tw(
        'absolute inset-y-[3px] right-[3px] flex items-center justify-center text-gray-400 hover:text-gray-200',
        props.className,
      )}
    />
  )
}

export const Search = Object.assign(SearchRoot, {
  Root: SearchRoot,
  IconRight: SearchIconRight,
})
